var _title, _g, _path, _path2, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconCircleCrop = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "aaced4f9-14e2-41eb-bd78-a9566a4aa330",
    "data-name": "Layer 1",
    viewBox: "0 0 36 36",
    ref: svgRef
  }, props), _title || (_title = /*#__PURE__*/React.createElement("title", null, "icon-circle-crop")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23,21.5V14a1,1,0,0,0-1-1H9",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13,14.5V22a1,1,0,0,0,1,1H27",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 13,
    y1: 11.5,
    x2: 13,
    y2: 9,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 23,
    y1: 27,
    x2: 23,
    y2: 24.5,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconCircleCrop, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-circle-crop.7bcda67b.svg";
export { ForwardRef as ReactComponent };